import { nanoid } from "nanoid";

const notificationConfig = {
  processes: {
    duration: 6,
    placement: 'topRight',
  },
  unreadMessage: {
    duration: 4.5,
    placement: 'bottomRight',
  },
  unreviewedApps: {
    duration: 4.5,
    placement: 'topRight',
    message: 'Новая заявка',
  }
}

const getNotificationConfig = (notificationType) => {
  return notificationConfig[notificationType]
}

export default getNotificationConfig;